module.exports = __webpack_public_path__ + "bbeab88bc89dfee7f20d858f1ffa07a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/28.jpg
// module id = 1355
// module chunks = 47